<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'manage-criteria'"
    @hidden="$emit('onCloseModal')"
    @show="fetchCriteriaData"
  >
    <b-form @submit.prevent="onSubmitModal">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header">
            {{ isEdit ? "Edit Criteria" : "Add Criteria" }}
          </div>
        </div>
      </div>
      <div class="modal-wrp mx-3">
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Priority'"
              label-for="priority"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="priority"
                v-model="formData.priority"
                :placeholder="'Input only number'"
                @input="onNumberInput($event, 'priority')"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Name'"
              label-for="name"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="name"
                v-model="formData.name"
                :placeholder="'ระบุ'"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div>
              <label for="flag-option-tag">
                <span class="font-medium-5">{{ "Tag" }}</span>
              </label>
              <v-select
                id="flag-option-tag"
                v-model="formData.tag"
                multiple
                class="tag-dropdown"
                :options="optionData.tagList"
                :class="[{ bypass: isEdit }]"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Note'"
              label-for="note"
              label-class="font-medium-5"
            >
              <b-form-input
                id="note"
                v-model="formData.note"
                :placeholder="'ระบุ'"
              />
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import useManageCriteriaModal from "../hooks/useManageCriteriaModal";
export default {
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: [Object, Array], default: null },
  },
  setup(props) {
    const {
      formData,
      optionData,
      onNumberInput,
      onSubmitModal,
      fetchCriteriaData,
    } = useManageCriteriaModal(props);

    return {
      formData,
      optionData,
      onNumberInput,
      onSubmitModal,
      fetchCriteriaData,
    };
  },
};
</script>

<style>
.modal .modal-header {
  display: none;
}

.modal-content {
  border-radius: 1.6rem;
}
</style>

<style scoped>
#manage-criteria .information-header {
  border-bottom: 1px solid #ececec;
  padding: 5px 40px 10px;
  font-size: 2.4rem !important;
  width: 100%;
}
</style>